import React from "react";
import Portrait from "./Portrait";

import Chips from "../../Chips";
import Tooltip from "../../Tooltip";

import { assetImg } from "@/modules/moduleImporter";

import nth0 from "@/modules/nth0";
import zeroFill from "@/modules/zeroFill";

import { isIPhone } from "@/modules/iOSDetection";
import { mouseOver, mouseLeave } from "@/modules/mouseInteractions";

import { IGameTableType } from "@/types/GlobalTypes";
import { betGroupProp } from "@/modules/commonMobile";

import nary from "@/modules/nary";

import "./index.scss";

export interface IProps extends Omit<IGameTableType, "win"> {
	win: BilliardsWinType
}

export interface BilliardsWinType {
	win: number,
	type: number
}

export default class M13 extends React.PureComponent<IProps> {
	state = { activeHover: "" };

	render() {
		const { langdata } = this.props;

		const win = this.props.win;

		const commonChipProps = {
			mobile: this.props.mobile,
			chipBase: this.props.chipBase,
			bets: this.props.bets,
			betOutOfBounds: this.props.betOutOfBounds
		}

		const commonTooltipProps = {
			langStr: langdata.language_code
		};

		const commonHoverHiddenProps = {
			onClick: this.props.insertBet,
			onMouseLeave: !isIPhone() ? mouseLeave.bind(this) : undefined,
			onMouseOver: !isIPhone() ? mouseOver.bind(this) : undefined
		};

		return (
			this.props.portrait ? <Portrait win={win} {...this.props} /> : (
				<div className={"sl-table table-m13"}>
					<div className="sides">
						<div className={"sl-bet sl-green-old" + (win && (win.win <= 7) ? " sl-yellow-alternating" : "")}>
							<div>{this.props.langdata["txt_small"]}</div>
							<div className="bet-type">1:1</div>
							<Chips {...commonChipProps} betKey="Small+n50" />
							<Tooltip {...commonTooltipProps} bet={this.props.bets["Small+n50"]} />
							<div className="sl-hover-hidden"
								{...betGroupProp(this, "Small", "n50")}
								{...commonHoverHiddenProps}></div>
						</div>

						<div className={"sl-bet sl-green-old" + (win && !!(win.type % 2) ? " sl-yellow-alternating" : "")}>
							<div>{this.props.langdata["txt_odd"]}</div>
							<div className="bet-type">1:0.95</div>
							<Chips {...commonChipProps} betKey="Odd+n50" />
							<Tooltip {...commonTooltipProps} bet={this.props.bets["Odd+n50"]} />
							<div className="sl-hover-hidden"
								{...betGroupProp(this, "Odd", "n50")}
								{...commonHoverHiddenProps}></div>
						</div>
					</div>

					<div className="mainbox-bet">
						<div className="row">
							{
								nary(5).map(num => {
									const betKey = [
										zeroFill(num, 2),
										zeroFill(num + 5, 2),
										zeroFill(num + 10, 2)
									].join(",");

									return (
										<div key={"m13_mainbox_" + num}
											className={"w-17 sl-bet sl-green-old col-header" +
												(win && (win.win % 5 === num) ? " sl-yellow-alternating" : "")}>

											<span>
												{this.props.langdata["txt_" + nth0(num - 1) + "_line"]}
											</span>

											<div className="bet-type">1:3,6</div>

											<Chips {...commonChipProps} betKey={betKey + "+n3"} />
											<Tooltip {...commonTooltipProps} bet={this.props.bets[betKey + "+n3"]} />

											<div className="sl-hover-hidden"
												{...{
													bet: betKey,
													pcode: this.props.pcode,
													group: "n3"
												}}
												{...commonHoverHiddenProps} />
										</div>
									);
								})
							}
						</div>

						{
							[
								["01", "02", "03", "04", "05"],
								["06", "07", "08", "09", "10"],
								["11", "12", "13", "14", "15"]].map(itemGroup =>
									<div key={"m13_betgroup_" + itemGroup.join(",")}
										className="row">
										{
											itemGroup.map((item) => {
												const activeHover = this.state.activeHover;
												const itemNum = Number(item);

												let styles = "";
												if ((activeHover === "Small" && itemNum < 8) ||
													(activeHover === "Big" && itemNum > 8) ||

													(activeHover.indexOf(item) >= 0))
													styles = " sl-bet-hover";

												if (win && win.win === itemNum)
													styles += " sl-yellow-alternating";

												return (
													<div key={"m13_bet" + item}
														className={"w-17 sl-bet sl-green-old" + styles}
														{...betGroupProp(this, item, "n")}
														onClick={this.props.insertBet}>
														{assetImg("m13", itemNum + "")}
														<div className="bet-type">1:13</div>
														<Chips {...commonChipProps} betKey={item + "+n"} />
														<Tooltip {...commonTooltipProps} bet={this.props.bets[item + "+n"]} />
													</div>
												);
											})
										}
										<div className={"w-15 sl-bet sl-green-old" + (win && itemGroup.indexOf(zeroFill(win.win, 2)) >= 0 ? " sl-yellow-alternating" : "")}>
											<span>{this.props.langdata["txt_2_to_1"]}</span>
											<div className="bet-type">1:1,75</div>
											<Chips {...commonChipProps} betKey={itemGroup.join(",") + "+n5"} />
											<Tooltip {...commonTooltipProps} bet={this.props.bets[itemGroup.join(",") + "+n5"]} />
											<div className="sl-hover-hidden"
												{...betGroupProp(this, itemGroup.join(","), "n5")}
												{...commonHoverHiddenProps}></div>
										</div>
									</div>
								)
						}
					</div>

					<div className="sides">
						<div className={"sl-bet sl-green-old" + (win && (win.win >= 9) ? " sl-yellow-alternating" : "")}>
							<div>{this.props.langdata["txt_big"]}</div>
							<div className="bet-type">1:1</div>
							<Chips {...commonChipProps} betKey="Big+n50" />
							<Tooltip {...commonTooltipProps} bet={this.props.bets["Big+n50"]} />
							<div className="sl-hover-hidden"
								{...betGroupProp(this, "Big", "n50")}
								{...commonHoverHiddenProps}></div>
						</div>

						<div className={"sl-bet sl-green-old" + (win && !(win.type % 2) ? " sl-yellow-alternating" : "")}>
							<div>{this.props.langdata["txt_even"]}</div>
							<div className="bet-type">1:0.95</div>
							<Chips {...commonChipProps} betKey="Even+n50" />
							<Tooltip {...commonTooltipProps} bet={this.props.bets["Even+n50"]} />
							<div className="sl-hover-hidden"
								{...betGroupProp(this, "Even", "n50")}
								{...commonHoverHiddenProps}></div>
						</div>
					</div>
				</div>
			)
		);
	}
}
